import type {
  CandidateSummary,
  SubmissionFilters,
} from '@repo/api/open-calls/graphql';

export type NavigationFilterKind = 'multiSelect' | 'range' | 'toggle';

export type NavigationFilterGroup = 'attributes' | 'profile';

export type NavigationFilterDefinition = {
  badgeLabel?: string;
  featuredValues?: string[];
  group?: NavigationFilterGroup;
  key: keyof SubmissionFilters | string;
  kind: NavigationFilterKind;
  label: string;
  rangeUnit?: string;
  sliderTitle?: string;
  summaryKey?: keyof CandidateSummary | string;
  unit?: string;
};

export const getFilterSummaryKey = (definition: NavigationFilterDefinition) =>
  definition.summaryKey ?? definition.key;

export const getFilterValue = (
  filters: Record<string, unknown> | undefined,
  definition: NavigationFilterDefinition,
) => filters?.[definition.key];

export const isFilterValueActive = (
  value: unknown,
  definition: NavigationFilterDefinition,
) => {
  if (definition.kind === 'toggle') return Boolean(value);
  if (Array.isArray(value)) return value.length > 0;
  return Boolean(value);
};

export const emptyFilterValue = (definition: NavigationFilterDefinition) =>
  definition.kind === 'toggle' ? false : [];
